// extracted by mini-css-extract-plugin
export default {"smNews":"SmallNews_smNews__mcfJn"};